import { useIntercomStore } from '@shared/stores/intercom.js'
import { onBeforeMount, onUnmounted, ref } from 'vue'

export function useHideIntercomLauncher (predicate = null) {
  const hideRequestId = ref(null)

  const { addHideRequest, removeHideRequest } = useIntercomStore()

  onBeforeMount(() => {
    hideRequestId.value = addHideRequest(predicate)
  })
  onUnmounted(() => {
    removeHideRequest(hideRequestId.value)
  })
}
